import { starterDeck } from "../builder";

export const KIDS_EN_RU_COLORS = starterDeck({
  id: "kids-en-ru-colors",
  name: "Цвета для детей (EN→RU)",
  name_en: "Colors for Kids (EN→RU)",
  description: "Самые яркие слова — учим вместе с ребёнком.",
  description_en: "The brightest words — learn together with your child.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "age_3_5",
  level: "A1",
  cards: [
    ["red", "красный"],
    ["blue", "синий"],
    ["green", "зелёный"],
    ["yellow", "жёлтый"],
    ["orange", "оранжевый"],
    ["purple", "фиолетовый"],
    ["pink", "розовый"],
    ["brown", "коричневый"],
    ["black", "чёрный"],
    ["white", "белый"],
    ["grey", "серый"],
  ],
});

export const KIDS_EN_RU_NUMBERS = starterDeck({
  id: "kids-en-ru-numbers",
  name: "Числа 1–10 (EN→RU)",
  name_en: "Numbers 1–10 (EN→RU)",
  description: "Первые числа от одного до десяти.",
  description_en: "The first numbers, from one to ten.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "age_3_5",
  level: "A1",
  cards: [
    ["one", "один"],
    ["two", "два"],
    ["three", "три"],
    ["four", "четыре"],
    ["five", "пять"],
    ["six", "шесть"],
    ["seven", "семь"],
    ["eight", "восемь"],
    ["nine", "девять"],
    ["ten", "десять"],
  ],
});

export const KIDS_EN_RU_ANIMALS = starterDeck({
  id: "kids-en-ru-animals",
  name: "Животные для детей (EN→RU)",
  name_en: "Animals for Kids (EN→RU)",
  description: "Домашние и дикие животные.",
  description_en: "Pets and wild animals.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "nature",
  ageGroup: "age_6_8",
  level: "A1",
  cards: [
    ["dog", "собака"],
    ["cat", "кошка"],
    ["cow", "корова"],
    ["horse", "лошадь"],
    ["pig", "свинья"],
    ["sheep", "овца"],
    ["chicken", "курица"],
    ["duck", "утка"],
    ["fish", "рыба"],
    ["bird", "птица"],
    ["bear", "медведь"],
    ["wolf", "волк"],
    ["fox", "лиса"],
    ["rabbit", "кролик"],
    ["squirrel", "белка"],
    ["lion", "лев"],
    ["tiger", "тигр"],
    ["elephant", "слон"],
    ["monkey", "обезьяна"],
    ["giraffe", "жираф"],
  ],
});

export const KIDS_EN_RU_FAMILY = starterDeck({
  id: "kids-en-ru-family",
  name: "Семья (EN→RU)",
  name_en: "Family (EN→RU)",
  description: "Слова о семье и близких.",
  description_en: "Words about family and loved ones.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "family",
  ageGroup: "age_6_8",
  level: "A1",
  cards: [
    ["mom", "мама"],
    ["dad", "папа"],
    ["mother", "мать"],
    ["father", "отец"],
    ["brother", "брат"],
    ["sister", "сестра"],
    ["son", "сын"],
    ["daughter", "дочь"],
    ["grandma", "бабушка"],
    ["grandpa", "дедушка"],
    ["uncle", "дядя"],
    ["aunt", "тётя"],
    ["cousin", "двоюродный брат / сестра"],
    ["baby", "малыш"],
    ["friend", "друг"],
  ],
});

export const KIDS_EN_RU_BODY = starterDeck({
  id: "kids-en-ru-body",
  name: "Части тела (EN→RU)",
  name_en: "Body Parts (EN→RU)",
  description: "Части тела для малышей.",
  description_en: "Body parts for little ones.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "anatomy",
  ageGroup: "age_6_8",
  level: "A1",
  cards: [
    ["head", "голова"],
    ["face", "лицо"],
    ["eye", "глаз"],
    ["ear", "ухо"],
    ["nose", "нос"],
    ["mouth", "рот"],
    ["tooth", "зуб"],
    ["hair", "волосы"],
    ["neck", "шея"],
    ["shoulder", "плечо"],
    ["arm", "рука"],
    ["hand", "кисть"],
    ["finger", "палец"],
    ["leg", "нога"],
    ["foot", "ступня"],
    ["back", "спина"],
    ["heart", "сердце"],
  ],
});
